import { DSL_API_PATH, DSL_BASE_URL } from '../../constants';
import HttpService from '../http-service/http-service';
import { SpcDataResponse, SpcDropdownData } from './spc-data-service.types';

export default class SpcDataService {
    async getAustraliaVinData(vin: string) {
        const url = DSL_BASE_URL + DSL_API_PATH.SPC_SERVICE_AUS_VIN;
        return HttpService.get<SpcDataResponse | any>(url, false, {
            headers: {
                ...HttpService.getAppIdRequestHeaders(),
                'X-VIN': vin,
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });
    }

    async getAustraliaYmmData(
        year: string,
        model: string,
        style: string,
        customerType: string
    ) {
        const url = DSL_BASE_URL + DSL_API_PATH.SPC_SERVICE_AUS_YMM;
        return HttpService.get<SpcDataResponse | any>(url, false, {
            headers: {
                ...HttpService.getAppIdRequestHeaders(),
            },
            params: {
                year: year,
                model: model,
                style: style,
                customerType: customerType,
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });
    }

    async getDropdownData(languageRegionCode: string) {
        if (languageRegionCode !== 'en-au' && languageRegionCode !== 'en-nz') {
            console.error(
                `Unsupported languageRegionCode: ${languageRegionCode}`
            );
            return {};
        }

        const url =
            languageRegionCode === 'en-au'
                ? DSL_BASE_URL + DSL_API_PATH.SPC_SERVICE_AUS_DROPDOWNS
                : DSL_BASE_URL + DSL_API_PATH.SPC_SERVICE_NZ_DROPDOWNS;
        return HttpService.get<SpcDropdownData | any>(url, false, {
            headers: {
                ...HttpService.getAppIdRequestHeaders(),
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });
    }

    async getNewZealandYmmData(
        year: string,
        model: string,
        style: string,
        engineAndTransmission: string
    ) {
        const url = DSL_BASE_URL + DSL_API_PATH.SPC_SERVICE_NZ_YMM;
        return HttpService.get<SpcDataResponse | any>(url, false, {
            headers: {
                ...HttpService.getAppIdRequestHeaders(),
            },
            params: {
                year: year,
                model: model,
                style: style,
                engineAndTransmission: engineAndTransmission,
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });
    }
}
